module.exports = __webpack_public_path__ + "img/3.9e0d9091.svg";